import { FC } from 'react';

import { TextPlaceholder } from '@gem/components';

import styles from './MenuItemsPlaceholder.styles.m.css';

export interface IMenuItemsPlaceholderProps {
  className?: string;
  count?: number;
}

export const MenuItemsPlaceholder: FC<IMenuItemsPlaceholderProps> = (props) => {
  const { className, count = 20 } = props;

  return (
    <div className={className}>
      {Array.from({ length: count }, (_, index) => (
        <div
          key={`item_${index}`}
          className={styles.itemContainer}
        >
          <TextPlaceholder width={300} />
        </div>
      ))}
    </div>
  );
};
